export default __webpack_public_path__ + "static/media/Icon-bookmark.0f5259fd.svg";